import { useState } from "react";
import { CalendarDays, Download, FileSpreadsheet, Loader2, Package } from "lucide-react";
import { toast } from "sonner";
import { apiError, downloadFile } from "@/lib/api";
import { useWorkspace } from "@/context/WorkspaceContext";
import { Panel } from "@/components/common";

const FORMATS = [["csv", "CSV spreadsheet", FileSpreadsheet], ["ics", "Calendar file (.ics)", CalendarDays], ["zip", "Platform content package", Package]];

export default function CampaignExport({ c }) {
  const { path } = useWorkspace();
  const [scope, setScope] = useState("approved");
  const [busy, setBusy] = useState("");
  if (!["strategy_approved", "active", "completed"].includes(c.status)) return null;
  const go = async (fmt) => {
    setBusy(fmt);
    try { await downloadFile(path(`/campaigns/${c.id}/export?format=${fmt}&scope=${scope}`), `cresqen-export.${fmt}`); toast.success("Export downloaded and logged"); }
    catch (e) { toast.error(apiError(e)); } finally { setBusy(""); }
  };
  return (
    <Panel title="Export for manual launch" eyebrow="Assisted launch" testId="campaign-export-panel">
      <p className="text-xs text-[#AAB6CC] mb-3">Campaign, platform, content type, approved copy, CTA, asset references, planned time, approval status, suggested tracking parameters and owner. Exports are for people to publish manually.</p>
      <div className="flex flex-wrap items-center gap-2">
        <select data-testid="campaign-export-scope" value={scope} onChange={(e) => setScope(e.target.value)} className="cq-input !py-1.5 !text-xs !w-auto">
          <option value="approved">Approved content only</option><option value="all">All content (with status)</option>
        </select>
        {FORMATS.map(([k, l, Icon]) => (
          <button key={k} data-testid={`campaign-export-${k}`} disabled={!!busy} onClick={() => go(k)} className="cq-btn cq-btn-ghost !py-1.5 !text-xs">
            {busy === k ? <Loader2 size={13} className="animate-spin" /> : <Icon size={13} />} {l} <Download size={11} className="opacity-60" />
          </button>))}
      </div>
    </Panel>
  );
}
